import { AppState } from '../../core/redux/rootReducer';
import { Channel, IChannelFromBE } from '../types/messages';
import { createProvidersMap } from '../utils';
import { environmentSelectors } from '../../environment/redux/environmentSelectors';

const messaging = (state: AppState) => state.messaging;

const channelsLoading = (state: AppState): boolean => messaging(state).channelsInLoad;

// All channels list from Firebase
const channelsList = (state: AppState): { [key: string]: Channel } => messaging(state).channels;

// Only active (non-archived) channels form BE
const channelsMap = (state: AppState): Record<string, IChannelFromBE> => messaging(state).channelsMap || {};

const channel = (channelId: string | undefined) => (state: AppState) => {
    if (!channelId || channelId === 'undefined') {
        return null;
    }

    const landLordName = environmentSelectors.landLordName(state);
    const channel = channelsList(state)[channelId];

    return {
        channel: channel ? { ...channel, name: landLordName } : null,
        metaData: channelsMap(state)?.[channelId] ?? null,
    };
};

const channelProvidersMap =
    (channelId: string | undefined) =>
    (state: AppState): Record<string, string> => {
        const map = channelsMap(state);

        if (!channelId || channelId === 'undefined' || !map) {
            return {};
        }

        return createProvidersMap(map[channelId]?.serviceProviderUsers);
    };

const newChatCreated = (state: AppState): { id: string } | null => state.messaging.newChatCreated;

const channelWithLandlordShouldBeCreated = (state: AppState): boolean => {
    const firebaseUser = state.firebase.user;
    const firebaseToken = state.firebase.token;
    const agreementUid = state.agreements.selectedAgreement?.uuid;
    const agreementId = state.agreements.selectedAgreement?.id;
    const channelsMap = agreementId && messaging(state).channelsMapByAgreement?.[agreementId];
    const channelsMapIsEmpty = typeof channelsMap === 'object' && Object.keys(channelsMap).length === 0;
    const isMessagingEnabled = environmentSelectors.isMessagingEnabled(state);

    return Boolean(
        firebaseUser && agreementUid && firebaseToken && channelsMapIsEmpty && isMessagingEnabled && channelsMapIsEmpty,
    );
};

const channelIds = (state: AppState): string[] => Object.keys(channelsList(state));
const previousSelected = (state: AppState): string | null => messaging(state).previousChannelId;
const newMessage = (state: AppState): string => messaging(state).newMessage;
const currentChannelId = (state: AppState): string | null => messaging(state).currentChannelId;

export const messagingSelectors = {
    channelsLoading,
    channelsList,
    channel,
    channelProvidersMap,
    channelsMap,
    newChatCreated,
    channelWithLandlordShouldBeCreated,
    channelIds,
    previousSelected,
    newMessage,
    currentChannelId,
};
